import { Button } from 'ui-components/src/components/atoms/Button';
import React from 'react';

import { Actions, Header, Message, StyledModal } from './styles';

export const ErrorView = ({ onLogout }: ErrorViewProps) => {
  return (
    <StyledModal active header={<Header>A critical error has occured</Header>}>
      <div>
        <Message>
          An error occurred which is preventing PortInsider from loading. The
          support team has been notified.
        </Message>
        <Message>Please click the button below to reload the page</Message>
        <Actions>
          {onLogout && (
            <Button secondary onClick={onLogout}>
              Log out
            </Button>
          )}
          <Button onClick={() => window.location.reload()}>Reload page</Button>
        </Actions>
      </div>
    </StyledModal>
  );
};

export interface ErrorViewProps {
  onLogout?: () => void;
}
